import { useState } from 'react'
import { DarkMode } from '@mui/icons-material'
import { 
  Box, 
  CircularProgress, 
  List, 
  ListItem, 
  ListItemIcon, 
  ListItemText, 
  ListSubheader, 
  Switch 
} from '@mui/material'
import { doc, updateDoc } from 'firebase/firestore'

import { firestore } from '../..'
import { useAuth } from '../../providers/auth'
import { useTheme } from '../../providers/theme'

export default function AccountSettings() {
  const { user } = useAuth()
  const { mode, setMode } = useTheme()
  const [loading, setLoading] = useState(false)

  const handleDarkMode = async () => {
    setLoading(true)
    const theme = mode === 'light' ? 'dark' : 'light'
    setMode(theme)
    const docRef = doc(firestore, 'users', user!.uid)
    await updateDoc(docRef, { theme })
    setLoading(false)
  }

  return (
    <Box my={2}>
      <List subheader={<ListSubheader disableSticky
        sx={{ backgroundColor: 'transparent' }}
      >Inställningar</ListSubheader>}>
        <ListItem>
          <ListItemIcon>
            <DarkMode />
          </ListItemIcon>
          <ListItemText
            primary="Dark mode"
          />
          {loading ? <CircularProgress /> : (
            <Switch
              edge="end"
              onChange={handleDarkMode}
              checked={mode === 'dark'}
              inputProps={{
                'aria-labelledby': 'switch-list-label-wifi',
              }}
            />
          )}
        </ListItem>
      </List>
    </Box>
  )
}
